'use strict';

/* globals RELATIVE_PATH, scrollToSmooth, socket */

require([
	RELATIVE_PATH + '/plugins/nodebb-plugin-lessons/static/vendor/vue.js',
	RELATIVE_PATH + '/plugins/nodebb-plugin-video/static/vendor/videojs/video.js',
], function (Vue, videojs) {
	var internals = {};

	Vue.component('lesson-questions', {
		props: ['initData'],
		data: function () {
			return {
				questions: this.initData.questions,
				currentQuestion: 0,
				canGoNext: false,
				questionToRepeat: false,
				isVisible: true,
				player: null,
			};
		},
		computed: {
			question: function () {
				return this.questions[this.currentQuestion];
			},
		},
		mounted: function () {
			this.initQuestion();
		},
		methods: {
			initQuestion: function () {
				this.initData.askedQuestions += 1;

				if (this.question.keyframes.start) {
					this.playLessonVideo();
				}
			},
			answered: function (isGoodAnswer) {
				if (!isGoodAnswer) {
					this.questionToRepeat = true;
					this.initData.invalidAnswers += 1;
				} else {
					this.canGoNext = true;
					this.initData.validAnswers += 1;
				}
			},
			nextQuestion: function () {
				this.$root.$emit('resetQuestion');

				// turned off repeating for now
				// if (this.questionToRepeat) {
				// 	this.questions.push(this.question);
				// }

				if (this.currentQuestion + 1 >= this.questions.length) {
					return this.finishLesson();
				}

				this.canGoNext = false;
				this.questionToRepeat = false;
				this.currentQuestion += 1;

				this.initQuestion();
			},
			finishLesson: function () {
				this.initData.isCompleted = true;

				internals.logFinishedLesson(this.initData.uuid);

				this.finishVideo();
			},
			playLessonVideo: function () {
				var _self = this;

				_self.player = videojs.getPlayer(_self.initData.player.id);

				if (!_self.player) {
					console.error('Lesson video player not found. Searching by id: ' + _self.initData.player.id);
					return;
				}

				_self.isVisible = false;

				if (_self.question.keyframes.start) {
					_self.playVideoPart(_self.question.keyframes.start);
				}

				var onTimeUpdate = function () {
					if (_self.player.currentTime() >= _self.question.keyframes.stop) {
						_self.isVisible = true;
						_self.player.pause();
						_self.player.off('timeupdate', onTimeUpdate);

						scrollToSmooth('#questions-container');
					}
				};

				_self.player.on('timeupdate', onTimeUpdate);
			},
			playVideoPart: function (startKeyframe) {
				this.player.currentTime(startKeyframe);
				this.player.play();

				scrollToSmooth('body');
			},
			finishVideo: function () {
				if (this.player && this.question.keyframes.stop) {
					this.playVideoPart(this.question.keyframes.stop);
				}
			},
		},
		template:
		'<div>' +
			'<div :style="{ display: !isVisible ? \'block\' : \'none\' }" class="text-center">' +
				'{{initData.translations.watchBeforeAnswer}}' +
			'</div>' +
			'<div :style="{ visibility: isVisible ? \'visible\' : \'hidden\' }">' +
				'<div class="text-center mb-4"><button :disabled="!canGoNext" v-on:click="nextQuestion()" class="btn btn-primary">{{initData.translations.nextQuestion}}</button></div>' +
				'<lesson-question :question="question" :init-data="initData" :answer-types="initData.answerTypes" :answered="answered"></lesson-question>' +
				'<div class="text-center mb-4"><button :disabled="!canGoNext" v-on:click="nextQuestion()" class="btn btn-primary">{{initData.translations.nextQuestion}}</button></div>' +
			'</div>' +
		'</div>',
	});

	internals.logFinishedLesson = function (uuid) {
		socket.emit('plugins.lessonsAnalytics.finishedLesson', { uuid: uuid });
	};
});
